import Lottie from 'lottie-react';

import faceTalkingAmazed from '../jsons/Face_Talking_Amazed.json';

const FaceTalkingAmazed = props => {
  return <Lottie animationData={faceTalkingAmazed} {...props} />;
};

export default FaceTalkingAmazed;
